import { Breakpoints } from './Breakpoints';
import { Spacing } from './Spacing';
import { Colors, createPalette, createSchemes, DefaultPalette, DefaultSchemes, } from './Colors';
import { Typography } from './Typography';
import { defaultScrollbars, createThemedScrollbars } from './Scrollbars';
import { Sizing } from './Sizing';
export function createTheme(partialTheme) {
    return {
        primary: partialTheme.primary ? partialTheme.primary : DefaultDarkTheme.primary,
        secondary: partialTheme.secondary ? partialTheme.secondary : DefaultDarkTheme.secondary,
        palette: { ...DefaultDarkTheme.palette, ...partialTheme.palette },
        schemes: { ...DefaultDarkTheme.schemes, ...partialTheme.schemes },
        gradients: { ...DefaultDarkTheme.gradients, ...partialTheme.gradients },
        typography: { ...DefaultDarkTheme.typography, ...partialTheme.typography },
        spacing: { ...DefaultDarkTheme.spacing, ...partialTheme.spacing },
        sizing: { ...DefaultDarkTheme.sizing, ...partialTheme.sizing },
        breakpoints: { ...DefaultDarkTheme.breakpoints, ...partialTheme.breakpoints },
        scrollbars: { ...DefaultDarkTheme.scrollbars, ...partialTheme.scrollbars },
        animationDurationMs: partialTheme.animationDurationMs
            ? partialTheme.animationDurationMs
            : DefaultDarkTheme.animationDurationMs,
    };
}
export const DefaultDarkTheme = {
    primary: Colors.black,
    secondary: Colors.white,
    palette: DefaultPalette,
    schemes: DefaultSchemes,
    gradients: {
        flare: {
            from: Colors.red,
            to: Colors.orange,
        },
        horizon: {
            from: Colors.orange,
            to: Colors.pink,
        },
        aurora: {
            from: Colors.blue,
            to: Colors.green,
        },
        galaxy: {
            from: Colors.blue,
            to: Colors.purple,
        },
        gravity: {
            from: Colors.purple,
            to: Colors.pink,
        },
        nebula: {
            from: Colors.purple,
            to: Colors.green,
        },
        grey: {
            from: Colors.grey5,
            to: Colors.grey5,
        },
    },
    typography: Typography,
    spacing: Spacing,
    sizing: Sizing,
    breakpoints: Breakpoints,
    scrollbars: defaultScrollbars,
    animationDurationMs: 300,
    isDark: true,
};
const lightPalette = createPalette({ primary: Colors.white, secondary: Colors.black });
export const DefaultLightTheme = {
    ...DefaultDarkTheme,
    primary: Colors.white,
    secondary: Colors.black,
    palette: lightPalette,
    schemes: createSchemes({ primary: Colors.white, secondary: Colors.black }),
    scrollbars: createThemedScrollbars(lightPalette),
    isDark: false,
};
export const resolveThemedValue = (value, theme) => {
    if (typeof value === 'function') {
        return value(theme);
    }
    return value;
};
//# sourceMappingURL=Theme.js.map